"use strict";

exports.__esModule = true;
exports.themeTransparentize = exports.themeDarken = exports.spacings = exports.lineHeights = exports.getThemeValues = exports.getTheme = exports.getArr = exports.fontWeights = exports.fontSizes = exports.defaultTheme = exports.defaultColors = exports.defaultColorRoles = exports.colors = exports.breakpoints = exports.arrToStyles = void 0;

var _ramda = require("ramda");

var _polished = require("polished");

var isHex = function isHex(color) {
  return /^#[0-9A-F]{6}$/i.test(color);
};

var defaultColors = {
  aqua: "#00a2b6",
  "aqua-2": "#00a2b6",
  black: "#000000",
  blue: "#005daa",
  "blue-1dx": "#276cb1",
  "blue-2": "#0033a0",
  boulder: "#7a7a7a",
  "color-info-search-grey": "#acacac",
  coolgray: "#4b555a",
  "coolgray-dark": "#2a2f32",
  crimson: "#e31215",
  dark: "#292f32",
  "dark-aqua": "#00acbd",
  "dark-blue": "#003b66",
  gray: "#e6e8e9",
  "gray-94": "#f0f0f0",
  "gray-border-bottom": "#cfd0d1",
  "gray-dark": "#222222",
  "gray-divider": "#eaeaea",
  "gray-drawer-base": "#272727",
  "gray-drawer-panel": "#313131",
  "gray-footer": "#b2b2b2",
  "gray-light": "#fafafa",
  "gray-menu": "#adadad",
  "gray-sub": "#777a7d",
  green: "#008d95",
  hollow: "rgba(0,0,0,0.05)",
  "hollow-inverted": "rgba(255,255,255,0.1)",
  light: "#fafafa",
  "light-aqua": "#89d1cc",
  "light-blue": "#70cfee",
  "light-blue-2": "#20b7e0",
  "light-grey": "#f8f8f8",
  "light-orange": "#ffb500",
  "light-purple": "#9d4d8c",
  "mine-shaft": "#3c3c3c",
  orange: "#f79111",
  "orange-2": "#f39100",
  purple: "#8f297c",
  red: "#ed2224",
  "red-1dx": "#e2231a",
  "red-2": "#e2231a",
  "red-bg-1dx": "#fce9e8",
  violet: "#8c3c93",
  white: "#ffffff",
  "white-alt": "#fafafa",
  "white-transparent": "rgba(255,255,255,0)"
};
exports.defaultColors = defaultColors;
var defaultColorRoles = {
  background: "white",
  "background-button": "aqua",
  "background-dark": "gray",
  "background-light": "light",
  border: "gray",
  "border-focus": "blue",
  "border-hover": "blue",
  divider: "gray-divider",
  error: "red-1dx",
  "error-background": "red-bg-1dx",
  icon: "aqua",
  "icon-input": "aqua",
  "icon-light": "white",
  placeholder: "gray",
  shadow: "black",
  success: "aqua",
  text: "gray",
  "text-light": "light",
  "text-mid": "gray-sub",
  "text-title": "dark",
  warning: "orange"
};
exports.defaultColorRoles = defaultColorRoles;
var breakpoints = [668, 1024, 1360];
exports.breakpoints = breakpoints;
var fontSizes = [12, 14, 16, 18, 20, 24, 32, 48, 64];
exports.fontSizes = fontSizes;
var lineHeights = [1, 1.2];
exports.lineHeights = lineHeights;
var fontWeights = [200, 400, 600];
exports.fontWeights = fontWeights;
var spacings = [0, 8, 16, 24, 32, 64];
exports.spacings = spacings;
var defaultTheme = {
  breakpoints: breakpoints,
  defaultColorRoles: defaultColorRoles,
  defaultColors: defaultColors,
  fontSizes: fontSizes,
  fontWeights: fontWeights,
  lineHeights: lineHeights,
  spacings: spacings
};
exports.defaultTheme = defaultTheme;

var themeKey = function themeKey(theme) {
  return JSON.stringify(theme);
};

var merge = (0, _ramda.memoizeWith)(themeKey, function (theme) {
  return (0, _ramda.mergeDeepRight)(defaultTheme, theme);
});

var getTheme = function getTheme(props) {
  var theme = (0, _ramda.prop)("theme", props);
  return theme ? merge(theme) : defaultTheme;
};

exports.getTheme = getTheme;

var getThemeValues = function getThemeValues(key, theme) {
  return (0, _ramda.prop)(key, theme);
};

exports.getThemeValues = getThemeValues;

var getColor = function getColor(colorRole, theme) {
  var themeColorRoles = (0, _ramda.prop)("colorRoles", theme);
  var themeColors = (0, _ramda.prop)("colors", theme);
  var colorName = (0, _ramda.propOr)(colorRole, colorRole, themeColorRoles);
  return (0, _ramda.propOr)(colorName, colorName, themeColors);
};

var colors = (0, _ramda.curry)(function (colorRole, props) {
  var theme = getTheme(props);
  return getColor(colorRole, theme);
});
exports.colors = colors;
var themeTransparentize = (0, _ramda.curry)(function (amount, colorName, props) {
  var color = colors(colorName, props);
  return isHex(color) && (0, _polished.transparentize)(amount, color);
});
exports.themeTransparentize = themeTransparentize;
var themeDarken = (0, _ramda.curry)(function (amount, colorName, props) {
  var color = colors(colorName, props);
  return isHex(color) && (0, _polished.darken)(amount, color);
});
exports.themeDarken = themeDarken;
var getArr = (0, _ramda.pipe)((0, _ramda.append)(_ramda.__, []), _ramda.unnest);
exports.getArr = getArr;
var arrToStyles = (0, _ramda.curry)(function (breakpts, vals) {
  return vals.reduce(function (accum, val, i) {
    return i === 0 ? "\n    " + val + "\n  " : "\n    " + accum + "\n    @media (min-width: " + breakpts[i - 1] + "px) {\n      " + val + "\n    }\n  ";
  }, "");
});
exports.arrToStyles = arrToStyles;